import * as React from 'react';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

interface StripePayFormProps {
  returnUrl: string;
}

export const StripePayForm = ({ returnUrl }: StripePayFormProps) => {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setSubmitting(true);
    setErrorMessage('');
    try {
      const result = await stripe.confirmPayment({
        elements,
        confirmParams: { return_url: returnUrl },
      });
      if (result.error?.message) {
        setErrorMessage(result.error.message);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement
        options={{
          layout: {
            type: 'accordion',
            defaultCollapsed: false,
            // radios: true,
            spacedAccordionItems: true,
          },
        }}
      />
      {!!errorMessage && <div className="text-danger mt-2">{errorMessage}</div>}
      <button type="submit" className="btn btn-primary mt-3" disabled={!stripe || !elements || submitting}>
        {submitting ? 'Processing…' : 'Pay now'}
      </button>
    </form>
  );
};
